import React, { Component } from 'react';

import language from '../../assets/languages/language';
export class SaveQuestion extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isContentSaved: false,
    };
  }

  setIconColor = async (func, isContentSaved) => {
    const { favItemId, onSaveItemChange, savePayLoad = {} } = this.props;
    let data = {};
    if (!Object.keys(savePayLoad).length) {
      data = { favItemId };
    } else {
      data = savePayLoad;
    }
    const response = await func(data);
    if (response.success) {
      onSaveItemChange(!isContentSaved);
      if (!isContentSaved) {
        const { setChildRef } = this.props;
        if (setChildRef) {
          setChildRef.deleteFlash();
        }
      }
      this.setState({ isContentSaved });
    } else {
      onSaveItemChange(true);
    }
  };
  setIconOnUnSave = async (func) => {
    const { favItemId, onSaveItemChange } = this.props;
    const data = {
      favItemId,
    };

    const response = await func(data);
    if (response.success) {
      onSaveItemChange(false);
      this.setState({ isContentSaved: true });
    } else {
      onSaveItemChange(true);
    }
  };
  componentDidMount = async () => {
    const { apiServiceProvider, favItemId, onSaveItemChange, savePayLoad = {} } = this.props;
    let data = {};
    if (!Object.keys(savePayLoad).length) {
      data = { favItemId };
    } else {
      data = savePayLoad;
    }
    const result = await apiServiceProvider['fetchSavedQuestion'](data);
    if (result.success) {
      onSaveItemChange(false);
      this.setState({ isContentSaved: true });
    } else {
      onSaveItemChange(true);
    }
  };

  componentDidUpdate = async (previousProps) => {
    if (previousProps.favItemId !== this.props.favItemId) {
      const { apiServiceProvider, favItemId, onSaveItemChange, savePayLoad } = this.props;
      let data = {};
      if (!Object.keys(savePayLoad).length) {
        data = { favItemId };
      } else {
        data = { ...savePayLoad };
      }
      this.setState({ isContentSaved: false });
      const result = await apiServiceProvider['fetchSavedQuestion'](data);
      if (result.success) {
        onSaveItemChange(false);
        this.setState({ isContentSaved: true });
      } else {
        onSaveItemChange(true);
      }
    }
  };

  render() {
    const { isContentSaved } = this.state;
    const { apiServiceProvider } = this.props;
    return (
      <span className='up tooltip-hover-questions' style={{ marginRight: '10px' }}>
        <div className='tootip_box'> {language.LC().SAVE_QUESTION} </div>
        <i
          className={`${
            isContentSaved
              ? 'fa fa-bookmark mark-action-btn-bookmark'
              : 'fa fa-bookmark-o mark-action-btn-bookmark'
          }`}
          onClick={() =>
            isContentSaved
              ? this.setIconColor(apiServiceProvider['deleteSavedQuestion'], false)
              : this.setIconColor(apiServiceProvider['saveQuestion'], true)
          }
          style={{ color: isContentSaved ? 'rgb(54, 141, 84)' : '' }}
        />
      </span>
    );
  }
}

export default SaveQuestion;



// WEBPACK FOOTER //
// ./src/Components-2025/QuestionBank/SaveQuestion.jsx